
import { BlogPost } from "@/types/blog";
import { content } from "./content";

export const FinanzcoachingVsFinanzberatung: BlogPost = {
  title: "Finanzcoaching vs. Finanzberatung: Ihr Kompass zur finanziellen Selbstbestimmung",
  metaTitle: "Finanzcoaching vs. Finanzberatung: Der Unterschied",
  excerpt: "Verloren im Dschungel der Finanzexperten? Dieser Ratgeber erklärt den Unterschied zwischen Beratern, Maklern & Coaches und hilft Ihnen, den richtigen Partner für Ihre finanzielle Souveränität zu finden.",
  date: "23.09.2024",
  lastUpdated: "24.03.2026",
  author: "Jörg Hörmann",
  authorTitle: "Finanz- & Executive Coach",
  slug: "finanzcoaching-vs-finanzberatung",
  imageUrl: "/images/blog/finanzcoaching-beratung.jpg",
  category: "Finanzcoaching",
  tags: ["Finanzcoaching", "Finanzberatung", "Honorarberatung", "Geld-Mindset", "Finanzielle Selbstbestimmung", "Finanzielle Klarheit", "Geld-Glaubenssätze", "Finanzplanung", "Einzelcoaching", "Vermögensberatung", "Finanzmakler", "Neurofinance", "Behavioral Finance", "Hochsensibilität"],
  metaDescription: "Finanzcoaching als Einzelcoaching: Unterschied zwischen Finanzberatung, Honorarberatung & Coaching. Ihr Weg zur finanziellen Selbstbestimmung.",
  content
};
